<template>
  <v-container  grid-list-xs>
    <v-row align="center" justify="center" class="mt-3">
      <v-col cols="12" lg="9" xl="9" class="text-justify">

        <v-row align="center" justify="center">
          <v-col cols="12" xl="8" lg="8" class="text-center">
            <h1> <p> Olimpiada Iberoamericana de Química </p></h1>
          </v-col>
        </v-row>

        <h3> <p> La Olimpiada Iberoamericana de Química nace en el año 1995, fue organizada por la República Argentina y participaron 8 
        países, el objetivo era realizar una olimpiada en la que participaran países de la región, con el fin de incrementar el intercambio 
        de experiencias y con la intención de que Iberoamérica alcanzara estándares internacionales de calidad de su docencia en ciencias químicas. Actualmente participan 17 países.</p></h3>

        <h3><p> La primera Olimpiada Iberoamericana fue un éxito y se acordó celebrar una segunda edición en México en 1996. El concurso se ha venido realizando anualmente
            , a excepción del año 2001, en el que Chile no pudo organizarla.</p></h3>

        <h3><p> La Olimpiada Iberoamericana de Química tiene la misma estructura que la Olimpiada Internacional, es una competencia para estudiantes 
            de nivel medio que no hayan cumplido los 19 años al 1° de octubre del año correspondiente al evento. Las Olimpiadas Iberoamericanas suelen 
            durar una semana y la Delegación de cada país está formada por cuatro estudiantes acompañados de un tutor o mentor, conjuntamente con un observador.</p></h3>

        <!-- <h3><p> Se acordó que en el 2016 la olimpiada se celebraría en Colombia y en el 2017 la realizó Perú.</p></h3> -->

        <h3><a href="https://rseq.org/olimpiadas-de-quimica/olimpiada-iberoamericana-de-quimica-historico/" target="_blank"> Saber más</a></h3>

      </v-col>
    </v-row>
  </v-container>  
</template>

<script>
export default {
  metaInfo: {
    title: 'Olimpiada Iberoamericana de Quimica',
    htmlAttrs: {
      lang: 'es',
      amp: true
    }
  },

}
</script>

<style>

</style>